/* ─── Navbar: scroll state + mobile hamburger ───────────────────────── */ 'use strict';
(function() {
    const navbar = document.getElementById('navbar');
    const toggle = document.getElementById('nav-toggle');
    const nav = document.getElementById('nav-menu');
    const backdrop = document.getElementById('nav-backdrop');
    if (!navbar || !toggle || !nav || !backdrop) return;
    const MOBILE_BP = 900; // matches CSS breakpoint
    const hasHero = document.getElementById('hero') !== null;
    function isMobile() {
        return window.innerWidth <= MOBILE_BP;
    }
    /* Scroll-based class — transparent only on pages that have a dark hero */ function onScroll() {
        if (hasHero && window.scrollY <= 60) {
            navbar.classList.add('navbar--top');
            navbar.classList.remove('navbar--scrolled');
        } else {
            navbar.classList.add('navbar--scrolled');
            navbar.classList.remove('navbar--top');
        }
    }
    window.addEventListener('scroll', onScroll, {
        passive: true
    });
    onScroll();
    /* Mobile menu open/close */ function openMenu() {
        nav.classList.add('is-open');
        nav.setAttribute('aria-hidden', 'false');
        toggle.setAttribute('aria-expanded', 'true');
        backdrop.classList.add('is-visible');
        document.body.style.overflow = 'hidden';
    }
    function closeMenu() {
        nav.classList.remove('is-open');
        if (isMobile()) nav.setAttribute('aria-hidden', 'true');
        else nav.removeAttribute('aria-hidden');
        toggle.setAttribute('aria-expanded', 'false');
        backdrop.classList.remove('is-visible');
        document.body.style.overflow = '';
    }
    /* Sync aria-hidden on resize */ function syncAriaHidden() {
        if (!isMobile()) nav.removeAttribute('aria-hidden');
        else if (!nav.classList.contains('is-open')) nav.setAttribute('aria-hidden', 'true');
    }
    toggle.addEventListener('click', function() {
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';
        if (isOpen) closeMenu();
        else openMenu();
    });
    backdrop.addEventListener('click', closeMenu);
    nav.querySelectorAll('a').forEach(function(link) {
        link.addEventListener('click', closeMenu);
    });
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') closeMenu();
    });
    window.addEventListener('resize', syncAriaHidden, {
        passive: true
    });
    syncAriaHidden();
})();

//# sourceMappingURL=project-6a0985f11bbc35ebaa3a06b4.15499691.js.map
